var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0415 17.412C7.85741 17.4127 7.67552 17.372 7.5092 17.2931C7.34288 17.2142 7.19635 17.0991 7.08037 16.9561L1.12879 9.56284C0.947558 9.34236 0.84848 9.0658 0.84848 8.78039C0.84848 8.49498 0.947558 8.21842 1.12879 7.99794L7.28985 0.60467C7.499 0.353032 7.79955 0.194786 8.12538 0.164745C8.45121 0.134704 8.77563 0.235328 9.02727 0.444482C9.2789 0.653636 9.43715 0.954186 9.46719 1.28002C9.49723 1.60584 9.39661 1.93026 9.18745 2.1819L3.67947 8.78655L9.00262 15.3912C9.1533 15.5721 9.24901 15.7923 9.27844 16.0259C9.30786 16.2594 9.26977 16.4966 9.16866 16.7091C9.06755 16.9217 8.90766 17.1009 8.7079 17.2255C8.50815 17.35 8.27689 17.4148 8.0415 17.412Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrBack);
export default __webpack_public_path__ + "static/media/arr_back.2883dbb4533824bb42b8fb7065190efe.svg";
export { ForwardRef as ReactComponent };